import { attributeGetter, Component } from "@bodil/dom/component";
import type { Role } from "aria-attribute-types";
import { html } from "lit";
import { customElement } from "lit/decorators.js";

import { BtkRadio } from "./radio";

import styles from "./radio-group.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "btk-radio-group": BtkRadioGroup;
    }
}

@customElement("btk-radio-group")
export class BtkRadioGroup extends Component {
    @attributeGetter get role(): Role {
        return "radiogroup";
    }

    get radios(): Array<BtkRadio> {
        return this.querySlot({ instanceOf: BtkRadio, flatten: true });
    }

    get value(): string {
        const active = this.radios.find((radio) => radio.checked);
        return active === undefined ? "" : active.value;
    }
    set value(v: string) {
        for (const radio of this.radios) {
            radio.checked = radio.value === v;
        }
    }

    protected override connected() {
        this.useWhileConnected(this.on("change", this.handleChange.bind(this)));
    }

    private handleChange(e: Event) {
        for (const radio of this.radios) {
            if (e.target !== radio) {
                radio.checked = false;
            }
        }
    }

    render() {
        return html`<slot></slot>`;
    }

    static styles = styles;
}
